// extracted by mini-css-extract-plugin
export default {"budgetHeader":"Budgets_budgetHeader__o28Gf","addBudgetBtn":"Budgets_addBudgetBtn__Rkubf"};